export default __webpack_public_path__ + "static/media/exit-module-logo.a29eade2.png";